export default {
    isLoggedIn(state) {
      return state.isLoggedIn;
    },
}



// WEBPACK FOOTER //
// ./src/store/modules/getters.js